class EmbroideryConfigurator extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.body = document.querySelector('body');
    this.bodyClass = 'embroidery-drawer-is-open';
    this.form = this.closest('form');
    this.bulkOrder = this.form.dataset.bulkOrder == 'true';
    this.productId = this.form.querySelector('[name=id]').value;
    this.productSize = '';
    this.productLine1 = this.dataset.productLine1;
    this.productLine2 = this.dataset.productLine2;
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.options = {
      product: 'Product',
      line: 'Line',
      font: 'Font',
      color: 'Color',
      text: 'Text',
    };

    // set elements to work with later on
    this.closeButton = this.querySelector('[data-embroidery-close]');
    this.embroideryStepButtons = this.querySelectorAll('[data-embroidery-step]');
    this.embroiderySize = this.querySelectorAll('[data-embroidery-size]');
    this.nextStepButton = this.querySelector('[data-embroidery-button-next]');
    this.previousStepButton = this.querySelector('[data-embroidery-button-previous]');
    this.preview = this.querySelector('[data-embroidery-preview]');
    this.previewButton = this.querySelector('[data-embroidery-preview-button]');
    this.previewLine1 = this.querySelectorAll('[data-embroidery-preview-line-1]');
    this.previewLine2 = this.querySelectorAll('[data-embroidery-preview-line-2]');
    this.embroideryNameLinesElem = this.querySelectorAll('[name="embroideryNameLines"]');

    // set elements we will work with
    this.summaryName = this.querySelector('[data-embroidery-summary-name]');
    this.summaryLogos = this.querySelector('[data-embroidery-summary-logos]');
    this.summaryNamePriceLine1 = this.querySelector('[data-embroidery-summary-price-line-1]');
    this.summaryNamePriceLine2 = this.querySelector('[data-embroidery-summary-price-line-2]');
    this.summaryLine2Container = this.querySelector('[data-embroidery-summary-line-2-container]');
    this.summaryNameLine1Text = this.querySelector('[data-embroidery-summary-line-1-text]');
    this.summaryNameLine1Font = this.querySelector('[data-embroidery-summary-line-1-font]');
    this.summaryNameLine1Color = this.querySelector('[data-embroidery-summary-line-1-color]');
    this.summaryNameLine2Text = this.querySelector('[data-embroidery-summary-line-2-text]');
    this.summaryNameLine2Font = this.querySelector('[data-embroidery-summary-line-2-font]');
    this.summaryNameLine2Color = this.querySelector('[data-embroidery-summary-line-2-color]');
    this.summaryAddToCart = this.querySelector('[data-embroidery-add-to-cart]');
    this.summaryLogoItems = this.querySelectorAll('[data-embroidery-summary-logo]');
    this.summaryAmount = this.querySelector('[data-embroidery-summary-amount]');
    this.agreeConditions = this.querySelector('[data-embroidery-agree-conditions]');

    // Set default values
    this.embroideryProductName = this.querySelector('[data-embroidery-product-name]').innerHTML;
    this.embroideryStep = ''; // step-name, step-logo, step-both
    this.embroideryNameLines = '0'; // 0, 1 or 2
    this.embroideryNameLine1Font = '';
    this.embroideryNameLine1FontClass = 'arial';
    this.embroideryNameLine1Color = '';
    this.embroideryNameLine1ColorHex = '';
    this.embroideryNameLine1Text = 'Line 1';
    this.embroideryNameLine2Font = '';
    this.embroideryNameLine2FontClass = 'arial';
    this.embroideryNameLine2Color = '';
    this.embroideryNameLine2ColorHex = '';
    this.embroideryNameLine2Text = 'Line 2';
    this.embroideryLogosMandatory = [];
    this.embroideryLogosOptional = [];
    this.configuratorAmount = 1;
    this.percentageComplete = 0;
    this.embroideryProgressSteps = '';
    this.embroideryAgreeConditions = false;
    this.uniqueSKU = '';

    // These are the available fonts classes that are used
    // Make sure this is in sync with all options provided in snippets/embroidery-configurator.liquid
    this.fontOptions = [
      'font-arial',
      'font-arial-black',
      'font-avante',
      'font-helvetica-large',
      'font-deja-vu-sans',
      'font-commercial-script',
      'font-adobe-caslon-pro-bold',
      'font-hobo',
      'font-lucida-calligraphy',
      'font-typewriter',
      'font-snickerdoodle',
      'font-milkshake',
      'font-doughnut',
      'font-cobbler',
      'font-gelato',
      'font-script',
      'font-times-new-roman',
      'font-century',
    ];

    // Set all possible steps that are possible
    // We define step progress with classes, so make sure we remove all of these with each step check as well
    this.stepOptions = [
      'step-intro',
      'step-name',
      'step-name-1-font',
      'step-name-1-color',
      'step-name-1-text',
      'step-name-2-font',
      'step-name-2-color',
      'step-name-2-text',
      'step-logo',
      'step-both',
      'step-summary',
    ];
    this.currentStep = 'step-intro';
    this.nextStep = '';
    this.previousStep = '';

    // Get current options form the element itself
    const dataOptions = JSON.parse(this.dataset.options);
    this.options = {
      ...this.options,
      ...dataOptions,
    };

    this.syncInputsWithOptions();
    this.bindEvents();
    this.setStep('step-intro');

    // Check how many options we have
    // If a customer only has name embroidering available, dive directly into that one
    if (this.embroideryStepButtons.length === 1) {
      this.embroideryStep = 'step-name';
      this.setStep('step-name');
    }
  }

  bindEvents = () => {
    this.closeButton.addEventListener('click', () => this.close());

    // Initial buttons when the configurator is launched
    this.embroideryStepButtons.forEach((elem) => {
      elem.addEventListener('click', () => {
        this.embroideryStep = elem.dataset.embroideryStep;

        if (this.embroideryStep === 'step-both') {
          this.currentStep = 'step-name';
        } else {
          this.currentStep = this.embroideryStep;
        }
        this.setStep(this.currentStep);
      });
    });

    this.summaryAmount?.addEventListener('change', (e) => {
      this.configuratorAmount = e.target.value;
    });

    // Catch clicks on the prev and next buttons
    this.previousStepButton.addEventListener('click', (e) => {
      if (this.previousStep !== '') this.setStep(this.previousStep);
      e.currentTarget.blur();
    });
    this.nextStepButton.addEventListener('click', (e) => {
      if (this.nextStep !== '') this.setStep(this.nextStep);
      e.currentTarget.blur();
    });

    // Toggle between zoomed and full preview
    this.previewButton.addEventListener('click', (e) => {
      this.preview.classList.toggle('full-preview');
    });

    // Listen for input events on the container and store the values
    this.container.addEventListener('input', (event) => {
      let exceptions = ['embroideryLogosOptional[]'];
      let target = event.target;

      if (typeof this[target.name] !== 'undefined') {
        this[target.name] = target.value;
        if (target.type == 'checkbox') {
          this[target.name] = target.checked;
        }

        if (target.dataset.embroidery_name_line_1_font_class) {
          this.embroideryNameLine1FontClass = target.dataset.embroidery_name_line_1_font_class;
        }
        if (target.dataset.embroidery_name_line_2_font_class) {
          this.embroideryNameLine2FontClass = target.dataset.embroidery_name_line_2_font_class;
        }
        if (target.dataset.embroidery_name_line_1_color_hex) {
          this.embroideryNameLine1ColorHex = target.dataset.embroidery_name_line_1_color_hex;
        }
        if (target.dataset.embroidery_name_line_2_color_hex) {
          this.embroideryNameLine2ColorHex = target.dataset.embroidery_name_line_2_color_hex;
        }
      } else if (exceptions.includes(target.name)) {
        // Fill the field as an array
        let values = [];
        let targetName = target.name.replace('[]', '');
        let allFields = this.container.querySelectorAll(`[name="${target.name}"`);

        allFields.forEach((elem) => {
          if (elem.checked) values.push(elem.value);
        });
        this[targetName] = values;
      }

      this.agreeConditions.classList.remove('text-danger');
      this.setStep(this.currentStep);
    });

    // Catch click on add to cart
    this.summaryAddToCart?.addEventListener('click', (event) => {
      // Conditions not yet agreed, scroll into view
      if (!this.embroideryAgreeConditions) {
        this.agreeConditions.classList.add('text-danger');
        this.agreeConditions.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      } else {
        // Execute add to cart
        this.addToCart(event);
      }
    });

    // Make sure we have the latest selected size
    this.getCurrentSize();
  };

  // Get the latest selected size and fill the title bar
  getCurrentSize = () => {
    document.querySelector('[data-option-position="0"]')?.addEventListener('input', (event) => {
      let sizeSelector = document.querySelector('.option__input-drawer:checked');

      if (sizeSelector) {
        this.productSize = sizeSelector.value;
        this.embroiderySize.forEach((elem) => {
          elem.innerHTML = `${sizeSelector.name}: ${sizeSelector.value}`;
        });
      }
    });
  };

  // Add to cart behavior
  // Base taken over from product-form.js but this caters a really specific usecase for the configurator
  addToCart = () => {
    this.summaryAddToCart.setAttribute('disabled', true);
    this.summaryAddToCart.classList.add('button--loading');

    const sectionsToFetch = [
      ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
      ...this.cartNotification.getSectionsToRender().map((section) => section.id),
    ];

    // Build up the array for the cart
    const productItemArray = [];
    if (this.bulkOrder) {
      this.form.querySelectorAll('[data-bulk-variant-id]').forEach((elem) => {
        if (elem.value > 0) {
          productItemArray.push({
            id: elem.dataset.bulkVariantId,
            quantity: elem.value,
            option: elem.dataset.bulkValue,
          });
        }
      });
    } else {
      productItemArray.push({
        id: this.form.querySelector('[name=id]').value,
        quantity: this.configuratorAmount,
        option: this.productSize,
      });
    }

    const allItems = [];
    let uniqueSKU = '';
    productItemArray.forEach((productItem) => {
      this.productId = productItem.id;
      uniqueSKU = this.buildUniqueSKU();

      allItems.push({
        id: productItem.id,
        quantity: productItem.quantity,
        properties: {
          _masterSKU: uniqueSKU,
        },
      });

      if (this.embroideryStep !== 'step-logo') {
        // Not a logo, so we have to add lines, always add the first line
        allItems.unshift({
          id: this.productLine1,
          quantity: productItem.quantity,
          properties: {
            [this.options.for]: `${this.embroideryProductName} (${productItem.option})`,
            [this.options.line + ' 1']: this.embroideryNameLine1Text,
            [this.options.font]: this.embroideryNameLine1Font,
            [this.options.color]: this.embroideryNameLine1Color,
            _productID: productItem.id,
            _linkedSKU: uniqueSKU,
          },
        });
        // Check if we have a second line
        if (this.embroideryNameLines == 2) {
          allItems.unshift({
            id: this.productLine2,
            quantity: productItem.quantity,
            properties: {
              [this.options.for]: `${this.embroideryProductName} (${productItem.option})`,
              [this.options.line + ' 2']: this.embroideryNameLine2Text,
              [this.options.font]: this.embroideryNameLine2Font,
              [this.options.color]: this.embroideryNameLine2Color,
              _productID: productItem.id,
              _linkedSKU: uniqueSKU,
            },
          });
        }
      }
      if (this.embroideryStep !== 'step-name') {
        // If we do not only have names to embroider, check all mandatory logos
        this.embroideryLogosMandatory.forEach((logo) => {
          allItems.unshift({
            id: logo,
            quantity: productItem.quantity,
            properties: {
              [this.options.for]: `${this.embroideryProductName} (${productItem.option})`,
              _productID: productItem.id,
              _linkedSKU: uniqueSKU,
              _mandatory: 'yes',
            },
          });
        });
        // Check all the optional logos
        this.embroideryLogosOptional.forEach((logo) => {
          allItems.unshift({
            id: logo,
            quantity: productItem.quantity,
            properties: {
              [this.options.for]: `${this.embroideryProductName} (${productItem.option})`,
              _productID: productItem.id,
              _linkedSKU: uniqueSKU,
              _mandatory: 'no',
            },
          });
        });
      }
    });

    // The array of items is complete, make sure we send extra data to rerender applicable sections
    const body = JSON.stringify({
      items: allItems,
      sections: sectionsToFetch,
      sections_url: window.location.pathname,
    });

    // This part has been taken over from product-form.js
    // A bit of duplicate code, but otherwise really custom for this plugin
    fetch(window.Shopify.routes.root + 'cart/add.js', { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status == 422) {
          // When quantity error
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderQuantityError(
            this.form.querySelector('[name=inventory_quantity]').value
          );
          return;
        }

        this.cartDrawer.renderContents(parsedState);
        setTimeout(() => {
          this.close(true);
          this.cartDrawer.open();
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.summaryAddToCart.classList.remove('button--loading');
        this.summaryAddToCart.removeAttribute('disabled');
      });
  };

  // Sync the state in this object to the inputs on the form itself
  syncInputsWithOptions = () => {
    this.embroideryNameLinesElem.forEach((elem) => {
      elem.checked = this.embroideryNameLines === elem.value;
    });

    // Get all mandatory logos
    let values = [];
    let allFields = this.container.querySelectorAll(`[name="embroideryLogosMandatory[]"`);

    allFields.forEach((elem) => {
      if (elem.checked) values.push(elem.value);
    });
    this.embroideryLogosMandatory = values;
  };

  // Set current step and define button states for next or previous steps
  setStep = (step = this.currentStep) => {
    this.currentStep = step;
    this.container.classList.remove(...this.stepOptions);
    this.container.classList.add(step);

    let totalSteps = 2,
      currentStepNumber = 0;
    if (this.embroideryStep === 'step-name') {
      if (this.embroideryNameLines == 1) {
        totalSteps = 4;
      } else if (this.embroideryNameLines == 2) {
        totalSteps = 7;
      }
    }
    if (this.embroideryStep === 'step-both') {
      if (this.embroideryNameLines == 1) {
        totalSteps = 5;
      } else if (this.embroideryNameLines == 2) {
        totalSteps = 8;
      }
    }

    switch (step) {
      case 'step-intro':
        this.previousStep = '';
        this.nextStep = 'step-name';
        break;
      case 'step-name':
        this.previousStep = 'step-intro';
        this.nextStep = 'step-name-1-font';

        if (this.embroideryNameLines == 0) {
          this.nextStep = '';
        }
        break;
      case 'step-name-1-font':
        this.previousStep = 'step-name';
        this.nextStep = `step-name-1-color`;
        currentStepNumber = 1;

        if (this.embroideryNameLine1Font === '') {
          this.nextStep = '';
        }
        break;
      case 'step-name-1-color':
        this.previousStep = 'step-name-1-font';
        this.nextStep = 'step-name-1-text';
        currentStepNumber = 2;

        if (this.embroideryNameLine1Color === '') {
          this.nextStep = '';
        }
        break;
      case 'step-name-1-text':
        this.previousStep = 'step-name-1-color';
        this.nextStep = 'step-summary';
        currentStepNumber = 3;

        if (this.embroideryStep === 'step-both') {
          this.nextStep = 'step-logo';
        }
        if (this.embroideryNameLines == 2) {
          this.nextStep = 'step-name-2-font';
        }
        if (this.embroideryNameLine1Text === '') {
          this.nextStep = '';
        }
        break;
      case 'step-name-2-font':
        this.previousStep = 'step-name-1-text';
        this.nextStep = 'step-name-2-color';
        currentStepNumber = 4;

        if (this.embroideryNameLine2Font === '') {
          this.nextStep = '';
        }
        break;
      case 'step-name-2-color':
        this.previousStep = 'step-name-2-font';
        this.nextStep = 'step-name-2-text';
        currentStepNumber = 5;

        if (this.embroideryNameLine2Color === '') {
          this.nextStep = '';
        }
        break;
      case 'step-name-2-text':
        this.previousStep = 'step-name-2-color';
        this.nextStep = 'step-summary';
        currentStepNumber = 6;

        if (this.embroideryStep === 'step-both') {
          this.nextStep = 'step-logo';
        }
        if (this.embroideryNameLine2Text === '') {
          this.nextStep = '';
        }
        break;
      case 'step-logo':
        this.previousStep = 'step-intro';
        this.nextStep = 'step-summary';
        currentStepNumber = 1;

        if (this.embroideryStep === 'step-both') {
          if (this.embroideryNameLines == 1) {
            this.previousStep = 'step-name-1-text';
            currentStepNumber = 4;
          }
          if (this.embroideryNameLines == 2) {
            this.previousStep = 'step-name-2-text';
            currentStepNumber = 7;
          }
        }
        if (
          this.embroideryLogosOptional.length === 0 &&
          this.embroideryLogosMandatory.length === 0
        ) {
          this.nextStep = '';
        }
        break;
      case 'step-summary':
        this.previousStep = 'step-intro';
        this.nextStep = '';
        currentStepNumber = 2;

        if (this.embroideryStep === 'step-name') {
          if (this.embroideryNameLines == 1) {
            currentStepNumber = 4;
            this.previousStep = 'step-name-1-text';
          } else if (this.embroideryNameLines == 2) {
            currentStepNumber = 7;
            this.previousStep = 'step-name-2-text';
          }
        } else if (this.embroideryStep === 'step-both') {
          this.previousStep = 'step-logo';
          if (this.embroideryNameLines == 1) currentStepNumber = 5;
          if (this.embroideryNameLines == 2) currentStepNumber = 8;
        } else if (this.embroideryStep === 'step-logo') {
          this.previousStep = 'step-logo';
        }
        break;
    }

    this.percentageComplete = (currentStepNumber / totalSteps) * 100;
    if (currentStepNumber == 0) {
      this.embroideryProgressSteps = ``;
    } else {
      this.embroideryProgressSteps = `${currentStepNumber}/${totalSteps}`;
    }

    // Make sure we show the most recent progress and state
    this.updateProgress();
  };

  // Convert given text to a handle to easily compare with
  convertToHandle = (text) => {
    return text.replace(' ', '-').toLowerCase();
  };

  // Build up the unique SKU we supply to the cart
  // This way Shopify knows the distinctions between configured items with different values
  // This also groups exact same configurations into 1 item
  buildUniqueSKU = () => {
    let uniqueSKU = this.productId + '-' + this.embroideryStep;

    if (this.embroideryStep != 'step-logo') {
      uniqueSKU +=
        '-line1-' +
        this.embroideryNameLine1Font +
        '-' +
        this.embroideryNameLine1Color +
        '-' +
        this.embroideryNameLine1Text;

      if (this.embroideryNameLines == '2') {
        uniqueSKU +=
          '-line2-' +
          this.embroideryNameLine2Font +
          '-' +
          this.embroideryNameLine2Color +
          '-' +
          this.embroideryNameLine2Text;
      }
    }
    if (this.embroideryStep != 'step-name') {
      uniqueSKU += '-mandatory-logos-' + this.embroideryLogosMandatory.join('-');
      uniqueSKU += '-optional-logos-' + this.embroideryLogosOptional.join('-');
    }

    this.uniqueSKU = this.convertToHandle(uniqueSKU);
    return this.uniqueSKU;
  };

  //
  updateProgress = () => {
    this.buildUniqueSKU();

    this.container.querySelector('[data-embroidery-percentage-bar]').style.width =
      this.percentageComplete + '%';
    this.container.querySelector('[data-embroidery-progress-steps]').innerHTML =
      this.embroideryProgressSteps;
    this.previousStepButton.disabled = this.previousStep === '';
    this.nextStepButton.disabled = this.nextStep === '';

    // Set specific classes to make sure the preview is the latest state
    this.previewLine1.forEach((elem) => {
      elem.classList.remove(...this.fontOptions);
      elem.classList.add(this.embroideryNameLine1FontClass);
      elem.innerHTML = this.embroideryNameLine1Text;
      elem.style.color = this.embroideryNameLine1ColorHex;
    });

    if (this.embroideryNameLines == '1') {
      this.previewLine2.forEach((elem) => elem.classList.add('hidden'));
      this.summaryNamePriceLine1.classList.remove('hidden');
      this.summaryNamePriceLine2.classList.add('hidden');
      this.summaryLine2Container.classList.add('hidden');
    } else {
      this.previewLine2.forEach((elem) => {
        elem.classList.remove(...this.fontOptions, 'hidden');
        elem.classList.add(this.embroideryNameLine2FontClass);
        elem.innerHTML = this.embroideryNameLine2Text;
        elem.style.color = this.embroideryNameLine2ColorHex;
      });
      this.summaryNamePriceLine1.classList.add('hidden');
      this.summaryNamePriceLine2.classList.remove('hidden');
      this.summaryLine2Container.classList.remove('hidden');
    }

    this.summaryName.classList.toggle('hidden', this.embroideryStep == 'step-logo');
    this.preview.classList.toggle('hidden', this.embroideryStep == 'step-logo');
    this.previewButton.classList.toggle('hidden', this.embroideryStep == 'step-logo');
    this.summaryLogos.classList.toggle('hidden', this.embroideryStep == 'step-name');

    // Update preview elements with values
    this.summaryNameLine1Text.innerHTML = this.embroideryNameLine1Text;
    this.summaryNameLine1Font.innerHTML = this.embroideryNameLine1Font;
    this.summaryNameLine1Color.innerHTML = this.embroideryNameLine1Color;
    this.summaryNameLine2Text.innerHTML = this.embroideryNameLine2Text;
    this.summaryNameLine2Font.innerHTML = this.embroideryNameLine2Font;
    this.summaryNameLine2Color.innerHTML = this.embroideryNameLine2Color;

    // Check which logos we want to show in the summary of the order
    this.summaryLogoItems.forEach((elem) => {
      let productLogoID = elem.dataset.embroiderySummaryLogo;
      elem.classList.toggle(
        'hidden',
        !(
          productLogoID &&
          (this.embroideryLogosOptional.includes(productLogoID) ||
            this.embroideryLogosMandatory.includes(productLogoID))
        )
      );
    });
  };

  close(closeAll = false) {
    this.setStep('step-intro');
    this.body.classList.remove(this.bodyClass);

    if (closeAll) {
      this.body.classList.remove('size-drawer-is-open');
    }
  }
}

// Initialize this custom component
if (!customElements.get('embroidery-configurator')) {
  customElements.define('embroidery-configurator', EmbroideryConfigurator);
}
